// English translations
export const englishTranslations = {
  header: {
    title: "Partnerships & Collaborations",
    subtitle: "Trusted. Innovative. Collaborative.",
    breadcrumb: {
      home: "Home",
      current: "Partnerships & Collaborations"
    }
  },
  introduction: {
    paragraph1: "Over the past nearly three decades, our company has helped numerous organizations- public and private- to meet their goals and objectives through innovative technological solutions. We believe that at the heart of those successful projects has been the genuine collaborative nature of the relationship between us and our partners. Overall, our team has had extensive on-hand experience working on government and enterprise issues that have been dealt with through technological solutions. With us as support, our partners have been able to conduct their operations with ease and confidence.",
    paragraph2: "As Bangladesh grows in the global landscape and foreign investment in the country multiplies, our friends across the border will have to navigate the unique needs of the market here. We are willing to be that bridge to make your project more successful through technological innovation and local support."
  },
  howWeCanHelp: {
    title: "How We Can Help",
    subtitle: "When choosing us as your local partner in Bangladesh, you can expect:",
    services: [
      {
        title: "On-The-Ground Support",
        description: "Dealing with the hassle of time zones, cultural differences and language barriers makes international business difficult, as such we take that problem away by providing support for your project in Bangladesh."
      },
      {
        title: "Nationwide Reach",
        description: "We are able to ensure execution across the country beyond just the capital city, whether it be an urban or rural area."
      },
      {
        title: "Capacity and Capability to Work within Laws and Governance of Bangladesh",
        description: "With our familiarity with the laws of this country, we can help you by dealing with those complexities. Whether it be navigating government regulations or automating legal processes, we have got you covered. For instance, for the Ministry of Land we have automated land mutation laws and integrated NID verification, thus reducing processing time from 3 months to just 7 days."
      },
      {
        title: "Proven Expertise",
        description: "We bridge the gap between your global solutions and the local landscape. Adapting your software/platforms for local technologies and local user interfaces as well as seamlessly connecting your systems with local services, databases, and infrastructure is how we help. For instance, we built RAJUK's AI-powered plot management system with local payments for a seamless citizen portal."
      },
      {
        title: "Data Entry, Mapping & Scaling Solutions",
        description: "We deliver accurate, high-volume data entry and processing services. We also provide expert geo-mapping, territory creation, and map platform integration as well as multi and manage scalable IT infrastructure designed for business growth."
      },
      {
        title: "Maintenance & Operational Support",
        description: "We provide proactive monitoring and rapid issue resolution to minimize system downtime. Moreover, we provide comprehensive Annual Maintenance Contract (AMC) for predictable, cost-effective support as well as a dedicated 24/7 technical helpdesk with multilingual support. For instance, we established a dedicated citizen care call center for the Ministry of Land and are providing 24-month post-deployment support to the govt. of Bangladesh for maintaining, delivering ongoing tech support for BCIC, BIDA, a2i, RAJUK, and JICA."
      },
      {
        title: "Training & Capacity Building",
        description: "We conduct structured training programs (in-person and virtual) to drive product adoption and empower your local team and distributors with the knowledge they need to succeed. For instance, we have workshops for JICA, RAJUK, A2I, BIDA, UNDP, World Bank, BEPRC, BTRC, BHTPA, BCSIR, BASIS, projects. Moreover, we successfully launched live training management systems for NPO and BCIC."
      },
      {
        title: "Inclusive Culture",
        description: "Our 100+ member team, with 25% women and young professionals, drives innovation through diversity."
      }
    ]
  },
  trustedPartner: {
    title: "What Makes Us a Trusted Partner",
    subtitle: "Simply put, your needs are our priority and we go beyond basic one-size-fits-all solutions. With us, you will receive technological solutions that work for you specifically. Moreover, we have:",
    trackRecordTitle: "Our track record speaks for itself :",
    stats: [
      {
        number: "27+ Years",
        title: "Bangladesh's leading ITES company with near 3 decades of legacy."
      },
      {
        number: "300+",
        title: "Trusted by 300+ public sector entities, including 30+ Ministries"
      },
      {
        number: "10+",
        title: "Involvement in 10+ national/local e-Gov platforms"
      }
    ],
    trackRecord: [
      {
        text: "Engagement with customers for service & process simplification."
      },
      {
        text: "Experience of one of the largest 3rd party integrations in Bangladesh",
        linkText: "(To learn more)"
      },
      {
        text: "Successful implementation record of public data analytics in different Govt. entities. (Such as SDG tracking, A2i dashboard, Energy management, Public service management etc.)"
      },
      {
        text: "Managing servers & providing devOps services hosted in different data centers, including national data center and 4th-tier data center.",
        linkText: "(To learn more)"
      },
      {
        text: "Experience of management of large-scale data and data migration (The largest experience of 21+ million record with Data size 175+ TB)"
      },
      {
        text: "Experience of providing nationwide training services using our training platform."
      },
      {
        text: "Experiencing record digitization (such as data entry, scanning of documents and maps) for successful project roll-out.",
        linkText: "(To learn more)"
      },
      {
        text: "Experience of providing tech support services as required by the projects through our customer service platform",
        linkText: "(To learn more)"
      }
    ]
  },
  trackRecord: {
    title: "Our Track Record",
    subtitle: "Proven excellence in digital solutions delivery",
    items: [
      {
        icon: "/png/pc_1.png",
        alt: "Engagement",
        text: "Engagement with customers for service & process simplification.",
        hasLink: false,
      },
      {
        icon: "/png/pc_2.png",
        alt: "API Integration",
        text: "Experience of one of the largest 3rd party integrations in Bangladesh",
        hasLink: true,
        linkText: "(To learn more)",
        linkUrl: "/services/api-integration",
      },
      {
        icon: "/png/pc_3.png",
        alt: "Analytics",
        text: "Successful implementation record of public data analytics in different Govt. entities. (Such as SDG tracking, A2i dashboard, Energy management, Public service management etc.)",
        hasLink: false,
      },
      {
        icon: "/png/pc_4.png",
        alt: "Server Management",
        text: "Managing servers & providing devOps services hosted in different data centers, including national data center and 4th-tier data center.",
        hasLink: true,
        linkText: "(To learn more)",
        linkUrl: "/services/devops-services",
      },
      {
        icon: "/png/pc_5.png",
        alt: "Data Management",
        text: "Experience of management of large-scale data and data migration (The largest experience of 21+ million record with Data size 175+ TB)",
        hasLink: false,
      },
      {
        icon: "/png/pc_6.png",
        alt: "Training",
        text: "Experience of providing nationwide training services using our training platform.",
        hasLink: false,
      },
      {
        icon: "/png/pc_7.png",
        alt: "Digitization",
        text: "Experiencing record digitization (such as data entry, scanning of documents and maps) for successful project roll-out.",
        hasLink: true,
        linkText: "(To learn more)",
        linkUrl: "/services/record-digitization-services",
      },
      {
        icon: "/png/pc_8.png",
        alt: "Support",
        text: "Experience of providing tech support services as required by the projects through our customer service platform",
        hasLink: true,
        linkText: "(To learn more)",
        linkUrl: "/services/tech-support-services",
      },
    ],
  },
  collaboration: {
    title: "How We Can Collaborate With You",
    subtitle: "In a dynamic and diverse business landscape, different forms of partnership are needed depending on the needs of the project at hand. We adapt to that by providing you with options of potential modes of collaboration such as:",
    modes: [
      {
        title: "Technical Delivery Partner",
        description: "Provide complete expertise and seamless integration for consultants or projects."
      },
      {
        title: "Joint Proposals",
        description: "Co-create winning bids, for government RFPs, from G2P to health and education platforms."
      },
      {
        title: "Technology Licensing",
        description: "License and scale our platforms for your initiatives."
      },
      {
        title: "Outsourced Teams",
        description: "Offer dedicated development or support for time-bound mandates."
      },
      {
        title: "Framework Agreements",
        description: "Support long-term national rollouts or skill-off assignments with L&T after years."
      }
    ],
    conclusion: "We have always encouraged partnership with potential clients from a variety of sectors, whether that be on our home ground of Bangladesh or the global landscape. As such, as we move forward to a new era, we look forward to providing more high quality, tailored technological solutions across the globe through our team of trusted experts."
  },
  feedback: {
    question: "Was this information helpful to you?",
    yes: "Yes",
    no: "No",
    thankYou: "Thank you for your feedback!",
    modalTitle: "We're sorry to hear that. Please let us know how we can improve.",
    placeholder: "Text box - up to 250 characters",
    submit: "Submit"
  }
};